export { default } from './TermDescriptions'
